// First-party product events. Fire-and-forget; never block the AE path.
import { useEffect } from "react";
import { api } from "./api.js";

export const UI_ACTIONS = [
  "ui.page_view",
  "ui.home_opened",
  "ui.preprints_opened",
  "ui.preprint_opened",
  "ui.reviewers_opened",
  "ui.article_reviewers_opened",
  "ui.qc_opened",
] as const;

export type UiAction = (typeof UI_ACTIONS)[number];

export function track(action: UiAction, detail?: Record<string, unknown>): void {
  const entityId =
    typeof detail?.path === "string"
      ? detail.path
      : typeof detail?.id === "string"
        ? detail.id
        : "app";
  void api.post("/telemetry", { action, entityId, detail }).catch(() => {
    /* swallow — telemetry must not surface as a user-facing error */
  });
}

/** Fire once when the screen mounts (and again if id/path identity changes). */
export function useProductEvent(action: UiAction, detail?: Record<string, unknown>): void {
  const id = typeof detail?.id === "string" ? detail.id : "";
  const path = typeof detail?.path === "string" ? detail.path : "";
  useEffect(() => {
    track(action, detail);
    // Intentionally identity-only: do not retrigger on new object identity each render.
  }, [action, id, path]);
}
